import { userinfo } from '@/stores/counter'

export default function convertTime() {
  const user = userinfo()
  function getTime(timestamp:number) {
    const date = new Date(timestamp * 1000); // JavaScript 的 Date 对象接受毫秒数，所以要乘以1000
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始计数，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    // const hours = String(date.getHours()).padStart(2, '0');
    // const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}`;
    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  return {
    getTime
  }
}